import { css } from '@emotion/css';
import { Layout, theme } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useCurrentContextStore } from '../hooks/store/useCurrentContextStore.ts';
import { hasAnyRelevantRole, hasSomeRole, Role } from '../utils/user';
import { MainMenu } from './MainMenu';

const { useToken } = theme;
const { Sider } = Layout;

export const Sidebar: React.FC<{ aisSession: boolean }> = ({ aisSession }) => {
  const { token } = useToken();
  const auth = useAuth();
  const { currentDoctorId } = useCurrentContextStore();
  const [collapsed, setCollapsed] = useState(false);

  if (!hasAnyRelevantRole(auth.user) || (!currentDoctorId && !hasSomeRole([Role.ROLE_LR_MEDCOM], auth.user))) {
    return null;
  }

  const styles = css`
    overflow: auto;
    background-color: ${token.Menu?.subMenuItemBg} !important;
    border-right: 1px solid ${token.colorBorderSecondary};

    .ant-layout-sider-trigger {
      height: 40px !important;
      line-height: 40px !important;
    }
  `;
  return (
    <Sider width={256} collapsedWidth={81} collapsible collapsed={collapsed} onCollapse={setCollapsed} breakpoint="xl" className={styles}>
      <MainMenu aisSession={aisSession} />
    </Sider>
  );
};
